import { atom } from "recoil";

export const UnreadMatchingCount = atom<{ unread_count: number }>({
  key: "UnreadMatchingCount",
  default: {
    unread_count: 0,
  },
});
